module.exports = __webpack_public_path__ + "static/media/sx.253e1891.svg";